
  // Export
  module.exports =
  {

    // View scripts
    view:
    {

      // Method-wide scripts
      _init: function ()
      {

        // If the calendar is not empty
        if (!$('#calendar').is(':empty'))
        {
          APPLICATION._APPLICATION.processLinks('#calendar', 'Calendar', 'view')
        }

        // Otherwise
        else
        {
          APPLICATION._APPLICATION.load($('#calendar'), APPLICATION._PATH_PREFIX + 'calendar/month', 'Calendar', 'view')
        }

      }

    }

  }